export class BaseAccordionUIChild {
  constructor(el) {
    if (!el) {
      return;
    }

    this.elements = el.querySelectorAll('[data-base-accordion-item-ui]');

    if (!this.elements.length) {
      return;
    }

    this.init();
  }

  init() {
    this.closeAll();
    this.addHandlers();

    this.openAnchorElement();
    window.addEventListener('hashchange', () => {
      this.openAnchorElement();
    });
  }

  closeAll() {
    this.elements.forEach((el) => el.classList.remove('active'));
  }

  clickHandler(event) {
    if (event.currentTarget.classList.contains('active')) {
      // event.currentTarget.classList.remove('active');
      return;
    }

    this.closeAll();
    event.currentTarget.classList.add('active');
  }

  addHandlers() {
    this.elements.forEach((el) => el.addEventListener('click', this.clickHandler.bind(this)));
  }

  openAnchorElement() {
    const anchor = window.location.hash ? window.location.hash.substring(1) : null;

    if (anchor) {
      this.elements.forEach((el) => {
        if (el.getAttribute('data-base-accordion-item-ui') === anchor) {
          this.closeAll();
          el.classList.add('active');
        }
      });
    }
  }
}
